import { MeasureSource } from '@core/models/measure-source';
import { SimulationType } from '@core/models/simulation-metadata.model';
import { EquipmentType } from '@shared/gui/models/equipment.model';

import { Interval } from '../features/analysis/models/interval';
import { TreeViewSourceType } from '@shared/gui/models/tree-view.model';

export interface TimestreamMetric extends TimestreamMetricOutput {
  displayName?: string;
  unit: string;
  ouvrage: string;
  description: string;
  uptodate?: boolean;
  tree?: string;
  path?: Array<string>;
  pathJoin?: string;
  // kiara only
  simulationType: SimulationType;
  measureSource: MeasureSource;
  category: EquipmentType;
  measureType: string;
  phaseShift?: number;
  loadedPhaseShift?: number;
  isPhaseShiftCopy?: boolean;
}

export interface TimestreamMetricValue {
  timestamp: string;
  value: number;
  displayValue: string | number;
  status?: SimulationDataStatus;
}

export interface TimestreamMetricOutput {
  key: string;
  property: string;
  simulation: SimulationType;
  source: TreeViewSourceType;
  calculatedType: CalculatedType;
  metrics: Array<TimestreamMetricValue>;
}

export interface TimestreamMetricInput {
  table: string;
  key: string;
  simulationType: SimulationType;
  interval: Interval;
  startDate: string;
  endDate: string;
  metrics: Array<string>;
  timeZone?: string;
  metricSource?: TreeViewSourceType;
}

export interface TimestreamMetricUpdate {
  table: string;
  key: string;
  user?: string;
  data: Array<{
    metricName: string;
    metrics: Array<MetricUpdate>;
  }>;
}

export interface MetricUpdate {
  timestamp: string;
  value: number;
  status?: SimulationDataStatus;
}

export interface MetricChangeHistory {
  metricsChanged: Array<TimestreamMetricUpdate>;
}

export interface TimestreamRangeUpdate {
  table: string;
  key: string;
  metricName: string;
  startDate: string;
  startValue: number;
  endDate: string;
  endValue?: number;
  transfertType: TransfertType;
  user?: string;
  timeZone?: string;
}

export enum TransfertType {
  NONE,
  VALUE,
  PROFILE
}

export enum CalculatedType {
  STATUS, // valve_status...
  FLOW, // flow...
  OTHER // other
}

export enum SimulationDataStatus {
  DRAFT_FIELD, // M Bleu
  OK_FIELD, // M Vert
  DRAFT_GASX, // G Bleu
  OK_GASX, // G Vert
  DRAFT_TRANSFERRED, // T Bleu
  OK_TRANSFERRED, // T Vert
  DRAFT_FIELD_TRANSFERRED, // MT Bleu
  OK_FIELD_TRANSFERRED, // MT Vert
  NO_STATUS, // nothing displayed
  OK_REPLACED, // R Vert
  OK_FORCED, // FR Vert
  DRAFT_SEED, // C Bleu
  OK_SEED, // C Vert
  DRAFT_MIXED, // Rectangle Bleu (agrégat d'origines différentes)
  OK_MIXED // Rectangle Vert (agrégat d'origines différentes)
}

export interface TimestreamMetricStatusInput {
  table: string;
  key: string;
  simulationType: SimulationType;
  date: string;
  metrics: Array<string>;
}

export interface TimestreamMetricStatusOutput {
  metricName: string;
  status: SimulationDataStatus;
}

export interface TransfertMetricsInIntervalInput {
  data: Array<ObjectToTransfert>;
  startDate: string;
  endDate: string;
  user: string;
  timeZone?: string;
}

export interface ObjectToTransfert {
  table: string;
  key: string;
  metrics: Array<{
    name: string;
    transfertType: TransfertType;
  }>;
}
